import React from 'react';
import type { ComponentProps } from 'react';

import { FlexJustifyContent, Grid, GridItem } from 'common/components/Grid';
import RichContent from 'common/components/RichText/RichContent';
import CommonTabBar from '../../common-tab-bar/components/CommonTabBar';
import type { SeoTableProps } from './SeoTable';
import SeoTable from './SeoTable';
import { SeoBlockType } from './types';

export interface SeoSectionProps {
  type?: SeoBlockType;
  content?: string;
  options?: SeoTableProps;
  tabBar?: ComponentProps<typeof CommonTabBar>;
  isContentCenterAligned?: boolean;
  isContentWithReducedWidth?: boolean;
}

const SeoSection = ({
  type,
  tabBar,
  content,
  options,
  isContentCenterAligned = false,
  isContentWithReducedWidth = false,
}: SeoSectionProps) => (
  <Grid
    data-corgi-id="seo-section"
    data-testid="seo-section-grid"
    {...(isContentWithReducedWidth
      ? {
          justifyContent: FlexJustifyContent.CENTER,
        }
      : {})}
  >
    <GridItem {...(isContentWithReducedWidth ? { width: [1, 6 / 8, 8 / 12] } : {})}>
      {tabBar?.items?.length > 0 && <CommonTabBar {...tabBar} />}

      {type === SeoBlockType.TableOfContent ? (
        <SeoTable {...options} isContentCenterAligned={isContentCenterAligned} />
      ) : (
        <RichContent
          content={content}
          isCenterAligned={isContentCenterAligned}
          data-testid="seo-section"
        />
      )}
    </GridItem>
  </Grid>
);

export default SeoSection;
